import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { join, map, get } from 'lodash'
import { translate, utils } from 'parking-react-common'

import List from '../components/List'
import PromoCodeButton from './PromoCodeButton'


const PromoCodesList = ({ title, subtitle, dataURL, dataSelector, t }) => {
    const columns = [
        {
            key   : 'name',
            title : t('Name')
        },
        {
            key    : 'date',
            title  : t('Date Interval'),
            render : ({ rowData }) => join(
                map([get(rowData, 'start_moment'), get(rowData, 'stop_moment')], utils.formatPrettyDate), ' - '
            )
        },
        {
            key   : 'quantity',
            title : t('Quantity')
        },
        {
            key   : 'discount',
            title : `${t('Discount')} %`
        },
        {
            key    : 'enabled',
            title  : t('Enabled'),
            render : ({ rowData }) => (// eslint-disable-line react/prop-types
                (<PromoCodeButton promoCode={ rowData } />)
            )
        }
    ]

    return (
        <List
            title={ title || t('Promo Codes') }
            subtitle={ subtitle }
            columns={ columns }
            dataURL={ dataURL }
            dataSelector={ dataSelector }
            searchKeys={ ['name'] }
        />
    )
}

PromoCodesList.propTypes = {
    title        : PropTypes.node,
    subtitle     : PropTypes.node,
    dataSelector : PropTypes.func,
    dataURL      : PropTypes.string
}


export default translate()(connect()(PromoCodesList))
